import React from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import Scaffold from "../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import SettingsPersonalInfoContent from "./SettingsPersonalInfoContent";
import SettingsPersonalInfoActions from "./widget/SettingsPersonalInfoActions";
import SettingsPersonalInfoButtons from "./widget/SettingsPersonalInfoButtons";
import { SettingsPersonalProfileContextProvider } from "../../../provider/settings/manage_personal_profile/SettingsPersonalProfileContextProvider";

const SettingsPersonalInfoScreen = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <SettingsPersonalProfileContextProvider>
      <Scaffold
        appBarTitle={AppTranslation.text("personal_information")}
        appBarAction={<SettingsPersonalInfoActions />}
        bottomNavigationButton={<SettingsPersonalInfoButtons />}
      >
        <MainBodyContainer className="h-100">
          <SettingsPersonalInfoContent type={type} />
        </MainBodyContainer>
      </Scaffold>
    </SettingsPersonalProfileContextProvider>
  );
};

export default SettingsPersonalInfoScreen;
export const routeName: string = "/settings/personal-information";
